export default "__VITE_ASSET__7970813a__"